import * as React from "react";
import { MainLayout } from "../../components/Layout";
import Headline from "../../components/Headline";
import CancelCreditCard from "./CancelCreditCard";
import "./styles.scss";
import { Link } from "react-router-dom";
import { URL_PATHS } from "../../routes";

const PaymentCancelFinish = () => {
    return (
        <MainLayout>
            <Headline>有料会員プラン停止完了</Headline>
            <CancelCreditCard />
            <div className="finish-cation">
                有料会員を停止してもアカウントは削除されません。
                <br />
                <Link to={URL_PATHS.contractPaidMember()}>
                    退会申請は契約確認・変更から行えます。
                </Link>
            </div>
        </MainLayout>
    );
};

export default PaymentCancelFinish;
